export const getPath = (key: string, location: string | URL) => {
  const url = new URL(location)

  const replaceUrl = url.pathname.replace(/^\/[a-z]{2}(\/)?/, "/")
  return `/${key}${replaceUrl !== "/" ? replaceUrl : ""}`
}
export const calculateLanguagePercentage = (sentence: string) => {
  const japaneseRegex = /[\u3040-\u309F\u30A0-\u30FF\u4E00-\u9FFF]/

  const englishRegex = /[a-zA-Z]/

  const characters = sentence.split("")

  let japaneseCount = 0
  let englishCount = 0

  characters.forEach((char) => {
    if (japaneseRegex.test(char)) {
      japaneseCount++
    } else if (englishRegex.test(char)) {
      englishCount++
    }
  })

  const totalCharacters = japaneseCount + englishCount
  if (totalCharacters === 0) return { japanesePercentage: 0, englishPercentage: 0 }

  const japanesePercentage = (japaneseCount / totalCharacters) * 100
  const englishPercentage = (englishCount / totalCharacters) * 100

  return { japanesePercentage, englishPercentage }
}

export const extractContent = (input: string, langCode: string) => {
  const regex = new RegExp(`\\[${langCode}\\]([^\\[]+)`, "i")
  const match = input?.match(regex)
  return match ? match[1].trim() : ""
}

/** Replace newline characters with HTML `<br>` tags for email/HTML display. */
export const convertBreak = (value: string): string => value.replace(/\n/g, "<br>")

/** Format a byte count as a human-readable megabyte string, e.g. `"1.23mb"`. */
export const formatFileSizeMb = (bytes: number): string => (bytes / (1024 * 1024)).toFixed(2) + "mb"
